import validator from 'validator'
import { toNumber } from './DataConversion'

export function isFormValid(elements) {
  if (!Array.isArray(elements) || elements.length === 0) {
    return false
  }
  return elements.every((element) => {
    const priceComponents = element.priceComponents || []
    return priceComponents.every((pc) => {
      const hasPrice =
        pc.price !== '' &&
        pc.price != null &&
        validator.isFloat(String(pc.price), { min: 0 })
      const hasStepSize =
        pc.stepSize && validator.isFloat(String(pc.stepSize), { min: 0.01 })
      const hasType = pc.type && pc.type.length > 0
      return hasPrice && hasStepSize && hasType
    })
  })
}

export function normalizeElements(elements) {
  return (elements ?? []).map((element) => ({
    ...element,
    priceComponents: (element.priceComponents ?? []).map((pc) => ({
      ...pc,
      price: toNumber(pc.price),
      stepSize: toNumber(pc.stepSize),
      vat: toNumber(pc.vat),
    })),
  }))
}

export function normalizeTariffForCompare(src) {
  if (!src) return null

  const normalizeNumber = (v) => {
    if (v === '' || v === null || v === undefined) return null
    const n = Number(v)
    return Number.isNaN(n) ? null : n
  }

  const normalizeDate = (dateValue) => {
    if (!dateValue) return null
    const date = new Date(dateValue)
    date.setUTCHours(0, 0, 0, 0)
    return date.getTime()
  }

  return {
    name: src.name || '',
    type: src.type || '',
    startDate: normalizeDate(src.startDate),
    expiryDate: normalizeDate(src.expiryDate),

    minPriceExclVat: normalizeNumber(src.minPriceExclVat),
    maxPriceExclVat: normalizeNumber(src.maxPriceExclVat),
    minPriceInclVat: normalizeNumber(src.minPriceInclVat),
    maxPriceInclVat: normalizeNumber(src.maxPriceInclVat),

    elements: (src.elements || []).map((el) => ({
      priceComponents: (el.priceComponents || []).map((pc) => ({
        type: pc.type || '',
        price: normalizeNumber(pc.price),
        vat: normalizeNumber(pc.vat),
        stepSize: normalizeNumber(pc.stepSize),
      })),
      restrictions: el.restrictions
        ? {
            startTime: el.restrictions.startTime || '',
            endTime: el.restrictions.endTime || '',
            startDate: normalizeDate(el.restrictions.startDate),
            endDate: normalizeDate(el.restrictions.endDate),
            minKwh: normalizeNumber(el.restrictions.minKwh),
            maxKwh: normalizeNumber(el.restrictions.maxKwh),
            minCurrent: normalizeNumber(el.restrictions.minCurrent),
            maxCurrent: normalizeNumber(el.restrictions.maxCurrent),
            minPower: normalizeNumber(el.restrictions.minPower),
            maxPower: normalizeNumber(el.restrictions.maxPower),
            minDuration: normalizeNumber(el.restrictions.minDuration),
            maxDuration: normalizeNumber(el.restrictions.maxDuration),
            minParkingDuration: normalizeNumber(
              el.restrictions.minParkingDuration,
            ),
            maxParkingDuration: normalizeNumber(
              el.restrictions.maxParkingDuration,
            ),
          }
        : null,
    })),
  }
}
